/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Inclusive end date of the recurrence pattern (RFC-5545 UNTIL)
 */
export type RecurrenceRequestUntil = string | null;
